// Footer Script mainly to get proper padding

(function($) {
    let footer          = '#theme-footer';
    let content         = '#content';
    let $footerBanner   = $(footer + ' .banner-container');
    let footerBar       = '.theme-footer__info-bar';
    let footerBarClose  = `${footerBar}__close`;
    let hasFooterBar    = false;

    function footerContentPadding() {
        if( $(footer).length ) {
            let barHeight       = hasFooterBar ? $(footerBar).height() : 0;
            let footerHeight    = Math.ceil($(footer).outerHeight() + barHeight) - 1;
            $(content).css('padding-bottom', `${footerHeight}px`);
        }
    }

    function scaleBanner() {
        let $container = $footerBanner;
        let $image = $container.find('.banner');
        if( !$image.length ) return;
        scaleImageContainer($container, $image);
    }

    function parallaxBanner() {
        let $container = $footerBanner;
        let $image = $container.find('.banner');
        let containerView = elementInView($container);
        if( containerView === 'view' ) {
            parallaxImageContainer($container, $image);
        }
    }
    
    /**
     * Info bar needs to be sticky unless we hit the footer
     */
    function stickyFooterBar() {
        let $bar            = $(footerBar);
        let scrollTop       = $(window).scrollTop();
        let height          = $(window).height();
        let footerOffsetTop = $(footer).offset().top;
        let scrollDistance  = scrollTop + height;
        if( scrollDistance >= footerOffsetTop ) {
            $bar.removeClass('stuck');
        } else {
            $bar.addClass('stuck');
        }
    }
    
    /**
     * Hide the sticky footer bar
     */
    function closeFooterBar( $button ) {
        let $bar = $button.closest(footerBar);
        $bar.slideUp();
        if( getCookie('footerBar') !== 'hide' ){
            document.cookie = "footerBar=hide; path=/";
        }
    }

    $(document).ready(function() {
        footerContentPadding();
        hasFooterBar = $(footerBar).length;
        $(footerBarClose).on('click', function() { closeFooterBar($(this)) });
    });

    $(window).on('load', function() {
        footerContentPadding();
        scaleBanner();
        parallaxBanner();
    });
    
    //# - On Resize
    $(window).on('resize', function() {
        scaleBanner();
        footerContentPadding();
    });

    $(window).on('scroll', function() {
        parallaxBanner();
        if( hasFooterBar ) stickyFooterBar();
    });
})(jQuery);